import { ObjectValueType } from '@shared/utils/type.utils';
export const SizeType = {
  Large: 'large',
  Normal: 'normal',
  Small: 'small',
  ExtraSmall: 'extraSmall'
} as const;
export type SizeType = ObjectValueType<typeof SizeType>;